import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, Observable } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { BiddingService, ListResponse } from '@viewbid/ts-angular-client';
import {
    loadUserBidHistory,
    loadUserBidHistorySuccess,
    loadUserBidHistoryFailure,
} from './user-bid-history.actions';
import { Action } from '@ngrx/store';

@Injectable()
export class UserBidHistoryStateEffects {
    loadUserBidHistory$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(loadUserBidHistory),
            switchMap(
                ({
                    page,
                    pageSize,
                    query,
                    orderBy,
                }: {
                    page: number;
                    pageSize: number;
                    query: string;
                    orderBy?: string;
                }) =>
                    this.biddingService
                        .getMyBidHistory(page, pageSize, query, orderBy)
                        .pipe(
                            map((response: ListResponse) =>
                                loadUserBidHistorySuccess({ response }),
                            ),
                            catchError((error: Error) =>
                                of(loadUserBidHistoryFailure({ error })),
                            ),
                        ),
            ),
        ),
    );

    constructor(
        private actions$: Actions,
        private biddingService: BiddingService,
    ) {}
}
